import * as Diff2Html from 'diff2html';
import { createPatch } from 'diff';
import { Component } from '@angular/core';
import { BaseComponent } from 'src/app/components/base.component';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { combineLatest, distinctUntilChanged, filter, map, Observable, switchMap, takeUntil } from 'rxjs';
import { DocContentsService } from '@services/doc-contents.service';
import { ColorSchemeType } from 'diff2html/lib/types';
import { LexbeThemeService } from '@services/lexbe-theme.service';

@Component({
    selector: 'lex-doc-viewer-compare-content',
    templateUrl: './doc-viewer-compare-content.component.html',
    styleUrls: ['./doc-viewer-compare-content.component.scss'],
    standalone: false
})
export class DocViewerCompareContentComponent extends BaseComponent {
	public outputHtml$: Observable<string> = null;
	private currentDocumentId: string;
	private compareDocumentId: string;

	constructor(
		private docViewerStore: DocViewerStore,
		private docContentsService: DocContentsService,
		private themeService: LexbeThemeService
	) {
		super();

		const currentDocumentDiffText$ = this.docViewerStore.currentDocument$.pipe(
			filter(d => !!d.docId),
			switchMap((currentDocument) => {
				this.currentDocumentId = currentDocument.docId;
				return this.docContentsService.getContentTextForDiffing(this.currentDocumentId);
			}),
			takeUntil(this.destroy$)
		)

		const compareDocDiffText$ = this.docViewerStore.simpleState$.pipe(
			filter(cd => !!cd.compareDocumentId),
			distinctUntilChanged((a, b) => a.compareDocumentId === b.compareDocumentId),
			switchMap((cd) => {
				this.compareDocumentId = cd.compareDocumentId;
				return this.docContentsService.getContentTextForDiffing(this.compareDocumentId);
			}),
			takeUntil(this.destroy$)
		);

		const content$ = combineLatest([currentDocumentDiffText$, compareDocDiffText$]).pipe(
			map(([current, compare]) => {
				return {
					leftDocId: current.docId,
					leftContent: current.textForDiffing,
					rightDocId: compare.docId,
					rightContent: compare.textForDiffing
				};
			})
		);

		this.outputHtml$ = combineLatest([content$, this.themeService.isDarkMode$])
			.pipe(
				map(([content, isDarkMode]) => {
					const oldString = content.leftContent;
					const newString = content.rightContent;
					if (!oldString || !newString) return '';
					const unifiedDiff = createPatch('', oldString, newString, `Left Document ID: ${content.leftDocId}`, `Right Document ID: ${content.rightDocId}`, {context: Infinity});
					return Diff2Html.html(Diff2Html.parse(unifiedDiff), {
						outputFormat: 'side-by-side',
						drawFileList: false,
						matching: 'lines',
						colorScheme: (isDarkMode ? 'dark':'light') as ColorSchemeType
					});
				}));
	}
}
